import React from 'react';
import AutzuProMobile from './AutzuProMobile';
import '../LandingPageNYC/NYCVehicleTypes.css';
import AutzuEv from './AutzuEv';

const TorontoVehicleTypes = landing => (
  <div>
    <div className="nyc-vehicle-types">
      <div className="nyc-vehicle-types--container container">
        <div className="nyc-vehicle-types__container">
          <AutzuProMobile />
        </div>
      </div>
    </div>
    <AutzuEv location={'tor'} />
  </div>
);

export default TorontoVehicleTypes;



// WEBPACK FOOTER //
// ./src/components/Static/UberToronto/TorontoVehicleTypes.js